export const PRESENCE_UPDATE_HEARTBEAT_INTERVAL = 60000
export const PRESENCE_PING_THROTTLE = 5000
